<sproc-page-menu
  [menuItems]="menuItems()"
  [findActiveSection]="findActiveSection"
  [openLogoSrc]="'assets/logo/logo.svg'"
  [closedLogoSrc]="'assets/logo/logo-closed.svg'">
  <div class="build-version-content">
    <span
      [tuiHint]="versionHint"
      [tuiHintAppearance]="'dark'"
      [tuiHintDirection]="'right'"
    >
      Версия: {{ version }}
    </span>
  </div>
</sproc-page-menu>
<section class="main">
  <div class="main-header">
    <sma-page-toolbar class="main-header__portal-content"></sma-page-toolbar>
    <sma-user-info></sma-user-info>
  </div>
  <router-outlet></router-outlet>
</section>
